module.exports = __webpack_public_path__ + "static/img/Sam_Docherty_desktop.8bf2136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam_Docherty_desktop.jpg
// module id = kXkI
// module chunks = 0